import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-delete-job-template',
  templateUrl: './confirm-delete-job-template.component.html',
  styleUrls: ['./confirm-delete-job-template.component.scss']
})
export class ConfirmDeleteJobTemplateComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialogRef<ConfirmDeleteJobTemplateComponent>) { }

  ngOnInit(): void {
  }

  onCancel() {
    this.dialog.close(false);
  }

  onSubmit() {
    this.dialog.close(true);
  }
}
